// Utility function to trigger spotlight only after element is stable in layout
export function spotlightWhenStable(buttonRefOrSelector, options = {}) {
  // Initial delay to let modal animations start
  const initialDelay = options.initialDelay ?? 50;
  
  setTimeout(() => {
    let tries = 0, lastRect = null, stableFrames = 0;
    
    function check() {
      const btn = typeof buttonRefOrSelector === "string"
        ? document.querySelector(buttonRefOrSelector)
        : buttonRefOrSelector.current;
        
      if (!btn) {
        if (++tries < 20) return setTimeout(check, 50); // Try for up to 1 second
        return;
      }

      const rect = btn.getBoundingClientRect();
      
      // Check if element has size and position is stable (with small tolerance)
      if (
        rect.width > 0 && rect.height > 0 &&
        (!lastRect ||
          (Math.abs(rect.top - lastRect.top) < 1 &&
           Math.abs(rect.left - lastRect.left) < 1 &&
           Math.abs(rect.width - lastRect.width) < 1 &&
           Math.abs(rect.height - lastRect.height) < 1))
      ) {
        stableFrames++;
      } else {
        stableFrames = 0;
      }
      
      lastRect = rect;
      
      // Need 3 stable frames (~50ms of stability) before triggering
      if (stableFrames >= 3) {
        window.dispatchEvent(new CustomEvent("spotlight", {
          detail: {
            target: btn,
            label: options.label,
            disableAutoAdvance: options.disableAutoAdvance,
            showCloseButton: options.showCloseButton,
            onClose: options.onClose
          }
        }));
      } else if (tries++ < 60) { // Try for up to ~1 second
        requestAnimationFrame(check);
      }
    }
    
    check();
  }, initialDelay);
} 